import { useState } from "react";
import {
	Box,
	Typography,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { Payment } from "../types";

type PaymentCorrectionsDisplayProps = {
	payment: Pick<Payment, "expected_hours_correction" | "extra_hours_paid"> | null;
	canEditCorrections: boolean;
	onUpdate: (data: Partial<Payment>) => void;
};

export const PaymentCorrectionsDisplay = ({
	payment,
	canEditCorrections,
	onUpdate,
}: PaymentCorrectionsDisplayProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [expectedCorrection, setExpectedCorrection] = useState("");
	const [extraHoursPaid, setExtraHoursPaid] = useState("");

	const handleOpenModal = () => {
		setExpectedCorrection(payment?.expected_hours_correction != null ? String(payment.expected_hours_correction) : "");
		setExtraHoursPaid(payment?.extra_hours_paid != null ? String(payment.extra_hours_paid) : "");
		setIsModalOpen(true);
	};

	const handleSave = () => {
		const expectedValue = expectedCorrection === "" ? null : parseFloat(expectedCorrection);
		const extraValue = extraHoursPaid === "" ? null : parseFloat(extraHoursPaid);
		onUpdate({ expected_hours_correction: expectedValue, extra_hours_paid: extraValue });
		setIsModalOpen(false);
	};

	const formatValue = (value: number | null | undefined) => {
		if (value == null) return "-";
		return `${value}h`;
	};

	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				<Typography variant="h6" color="primary">
					Correções
				</Typography>
				{canEditCorrections && payment && (
					<IconButton size="small" onClick={handleOpenModal}>
						<Edit fontSize="small" />
					</IconButton>
				)}
			</Box>
			<Box sx={{ pt: 0.5 }}>
				<Typography variant="body1">
					Correção Esperadas: {formatValue(payment?.expected_hours_correction)}
				</Typography>
				<Typography variant="body1">
					Horas Extra Pagas: {formatValue(payment?.extra_hours_paid)}
				</Typography>
			</Box>

			<Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} maxWidth="xs" fullWidth>
				<DialogTitle>Correções de Horas</DialogTitle>
				<DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
					<TextField
						label="Correção horas esperadas"
						type="number"
						size="small"
						value={expectedCorrection}
						onChange={(e) => setExpectedCorrection(e.target.value)}
						fullWidth
						sx={{ mt: 1 }}
					/>
					<TextField
						label="Horas extra pagas"
						type="number"
						size="small"
						value={extraHoursPaid}
						onChange={(e) => setExtraHoursPaid(e.target.value)}
						fullWidth
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
					<Button onClick={handleSave} variant="contained">Guardar</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};
